<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-11-06 16:38:12
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-03-15 16:35:18
 * @FilePath: \front\src\views\System\dataManage\dataBatchModify.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="about">
        <el-form ref="form" :rules="rules" :model="form.form" label-width="120px">
            <el-form-item label="科室名称" prop="departments">
                <el-select size="small" filterable clearable placeholder="请选择" v-model="form.form.departments">
                    <el-option v-for="item in form.deptList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-row class="manageState">
                <el-col>
                    <el-form-item :label="textState[currentTab][0]+'状态'" prop="oldState">
                        <el-select v-model="form.form.oldState" :style="{ width: '100%' }" placeholder="请选择">
                            <el-option v-for="(item, index) in options" :key="index" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <template v-if="childTab!='t5'&&currentTab!='t6'">
                    <el-col class="col2">
                        <p>修改为</p>
                    </el-col>
                    <el-col class="col3">
                        <el-form-item prop="newState">
                            <el-select v-if="currentTab=='t4'" v-model="form.form.newState" :style="{ width: '100%' }" placeholder="请选择" @change="handleChange">
                                <el-option key="4" label="终止随访"
                                    value="4" />
                            </el-select>
                            <el-select v-else v-model="form.form.newState" :style="{ width: '100%' }" placeholder="请选择">
                                <el-option v-for="(item, index) in options" :key="index" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
            <template v-if="stopFlag">
                <el-form-item label="终止类型">
                    <el-select v-model="form.form.stopType" :style="{ width: '100%' }" placeholder="请选择" @change="stopHandleChange">
                       <el-option v-for="(item, index) in stopOption" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="终止原因">
                    <el-input
                        v-model="form.form.stopReason"
                        placeholder="请输入"
                        clearable
                    />
                </el-form-item>
            </template>
            <el-form-item :label="childTab=='t7'? '预约时间(起)':textState[currentTab][1]+'时间(起)'">
                <el-date-picker v-model="form.form.startDate" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="childTab=='t7'? '预约时间(止)':textState[currentTab][1]+'时间(止)'">
                <el-date-picker v-model="form.form.endDate" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="formBot">
                <el-button>取 消</el-button>
                <el-button type="primary" :loading="isLoading" @click="openTips">确 定</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import api from '@/service/api.js';
import dayjs from 'dayjs';


export default {
    props:{
        form:{
            require:true
        },
        options:{
            require:true
        },
        isLoading:{
            require:true
        },
        currentTab:{
            require:true
        },
        childTab:{
            require:true
        }
    },
    watch: {
        childTab(newValue) {
            // 当父组件的值变化时，这里会触发
            this.childTab = newValue;
            console.log('New value in child component:', newValue);
        }
    },
    data() {
        return {
            rules: {
				// departments: {required: true, message: '请选择', trigger: 'blur'},
				oldState: {required: true, message: '请选择', trigger: 'blur'},
				newState:{required: true, message: '请选择', trigger: 'blur'}
			},
            textState:{
                't1':['管理','入院'],
                't2':['排期','出院'],
                't3':['排期','门诊'],
                't4':['随访','出院'],
                't6':['复诊','出院'],
            },
            stopOption:[
                {
                    value:1,
                    label:'单次终止'
                },
                {
                    value:2,
                    label:'全部终止'
                }
            ],
            stopFlag:false
        }
    },
    async created() {
        console.log(this.childTab,'---------',this.currentTab);
    },
    methods: {
        openTips(){
            this.$refs['form'].validate(async (valid)=>{
				if (valid) {
                    console.log(this.form.form,'--------fff');

                    this.$emit('openTipsEvent', this.form.form);
				}
			})
        },
        handleChange(value){
            if(this.currentTab=='t4'&&value==4){
                this.stopFlag=true
            } else{
                this.stopFlag=false
            }
        },
        stopHandleChange(value){
            if(value==2){
                this.textState['t4'][1]='应随访'
            } else {
                this.textState['t4'][1]='出院'
            }
            console.log(value,'---------va');
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

// .el-tabs {
//     &.customize {
//         .el-tabs__nav-wrap {
//             padding: 10px 30px 12px;

//             &::after {
//                 display: none !important;
//             }
//         }

//         .el-tab-pane {
//             &.pad {
//                 padding: 10px 30px 20px;
//             }
//         }
//     }
// }

.el-form {
    width: 510px;
    margin: 0 auto;
    padding: 80px 0;
}

.manageState {
    display: flex;

    .col2 {
        p {
            white-space: nowrap;
            margin: 0 12px;
            line-height: 40px;
            text-align: center;
        }
    }

    .col3 {
        ::v-deep .el-form-item__content {
            margin-left: 0 !important;
        }
    }

    ::v-deep .el-input:not(.el-transfer-panel__filter) {
        width: 150px;
    }
}

.formBot {
    text-align: center;
    margin-top: 80px;

    ::v-deep .el-form-item__content {
        margin-left: 0 !important;
    }

    .el-button {
        width: 100px;
        margin: 0 16px;
    }
}
</style>